<template>
    <v-row justify="center">
        <v-dialog v-model="dialog" persistent max-width="600px" @keydown.esc.stop="close">
            <v-card>
                <v-card-title class="text-h5 bg-grey-lighten-2">
                    <span class="text-h5">Create a Run</span>
                </v-card-title>
                <v-card-text class="mt-5">
                    <v-form class="" v-model="isFormValid" ref="form">
                        <v-text-field
                            type="date"
                            v-model="runDate"
                            label="Expected Run Date"
                            clearable
                            :rules="collectionDateRequired"
                        >
                        </v-text-field>
                        <v-autocomplete
                            v-model="selectedProtocols"
                            return-object
                            :items="filteredProtocols"
                            item-title="name"
                            label="Select a Protocol"
                            :rules="false ? protocolRulesMore : protocolRulesSingle"
                            :multiple="false"
                            required
                            searchable="false"
                            autofocus
                        >
                        </v-autocomplete>
                    </v-form>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" size="small" variant="text" @click="close">Cancel</v-btn>
                    <v-btn
                        color="primary"
                        :disabled="!isFormValid || creating"
                        @click="proceed"
                        class="mr-3"
                        :loading="creating"
                    >
                        Create Run
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-row>
</template>
<script>
import { defineComponent } from "vue";

import _ from "lodash";
import axios from "../../lib/apiAxios";
import { EventBus } from "../../lib/event-bus";

export default defineComponent({
    name: "CreateDialog",

    data() {
        return {
            creating: false,
            runDate: "",
            dialog: true,
            protocolArray: [],
            reqTypes: ["Molecular", "Analytical", "Outsource"],
            selectedProtocols: [],
            isFormValid: false,
            protocolRulesMore: [(v) => (v.length > 0 ? true : "Select one or more protocols")],
            protocolRulesSingle: [(v) => (_.has(v, "registry_id") ? true : "Select a protocol")],
            collectionDateRequired: [(v) => (v ? true : "Collection Date is required")],
        };
    },

    computed: {
        protocolLabel: function () {
            return "Select a Protocol";
        },
        filteredProtocols: function () {
            return this.protocolArray.filter(
                (protocol) => protocol.functional_team === "Analytical"
            );
        },
    },

    created() {
        this.init();
        this.runDate = new Date().toISOString().slice(0, 10);
    },

    methods: {
        async init() {
            try {
                // Get Protocols
                const res = await axios.get(`/benchling/registries/protocols?isFunctional=true`);
                this.protocolArray = res.data;

                // Get Containers
                const response = await axios.get(`/container/types`);
                this.containerTypeArray = response.data;
            } catch (err) {
                console.error(err);
                EventBus.$emit(
                    "message",
                    "Error loading dialog data. Please refresh your browser."
                );
            }
        },

        // Submit form (proceed)
        proceed() {
            this.creating = true;
            // Emit selections to parent
            this.$emit("submit", {
                runDate: new Date(this.runDate).toISOString(),
                protocols: _.isArray(this.selectedProtocols)
                    ? this.selectedProtocols
                    : [this.selectedProtocols],
            });
        },
        close() {
            this.dialog = false;
            this.$refs.form.reset();
            window.history.back();
        },
    },

    watch: {
        $route: function () {
            if (this.$route.query.type !== "create") {
                this.dialog = false;
                this.$refs.form.reset();
            }
        },
    },
});
</script>

<style scoped></style>
